import { render } from "./Community.vue.js?vue&type=template&id=56f93626!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Community.vue?vue&type=template&id=56f93626"
import script from "./Community.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Community.vue?vue&type=script&lang=js"
export * from "./Community.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Community.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/Community.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56f93626"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56f93626', __exports__)) {
    api.reload('56f93626', __exports__)
  }
  
  module.hot.accept("./Community.vue.js?vue&type=template&id=56f93626!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Community.vue?vue&type=template&id=56f93626", () => {
    api.rerender('56f93626', render)
  })

}


export default __exports__